import VueI18n from 'vue-i18n'

import ru from './ru-RU.js'
import en from './en-US.js'

export default lang => new VueI18n({
  locale: lang,
  messages: {
    en: en,
    ru: ru,
    'en-GB': en,
    'en-US': en,
    'ru-RU': ru
  }
})
